import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';
import { dateFormatter, getCurrentDateTime } from '../../../../../utils';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.8,
    backgroundColor: 'black',
    marginVertical: 0
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer1: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '0.5px solid black'
  },
  fontBold: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold',
    textDecoration: 'underline'
  },
  column: {
    flex: 1,
    padding: 3
  },
  wideColumn: {
    flex: 2,
    padding: 3
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    marginTop: 5
  },
  tableRow: {
    flexDirection: 'row'
  },
  tableColHeader: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    backgroundColor: '#f0f0f0',
    padding: 5
  },
  tableCol: {
    width: '20.28%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#bfbfbf',
    padding: 5
  },
  tableCellHeader: {
    fontSize: 10,
    fontWeight: 'bold'
  },
  tableCell: {
    fontSize: 10
  },
  voidBox: {
    width: 20,          // Adjust the width of the box as needed
    height: 20,         // Adjust the height of the box as needed
    borderWidth: 1,     // Optional: Add a border to make it a box
    borderColor: '#000', // Optional: Color of the box border
    marginRight: 10,    // Space between the box and the text
  },
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const IndoorRegisterationPDF = ({ data }) => {
  console.log(data);
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const formatRegTime = (time) => {
    const [hours, minutes] = time.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    
    // Format to 12-hour time
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    return date.toLocaleTimeString('en-US', options);
  }
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title={`IPD Registeration`}>
          <Page size="A4" style={styles.page}>
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <View style={{ ...styles.row, borderTop: '1px solid black' }}>
              <Text
                content="ADDMISSION REGISTRATION FORM"
                style={{ fontSize: '9px', margin: '0 auto', textDecoration: 'underline' }}
              />
            </View>
            {/* First Row */}
            <View style={styles.contentContainer1}>
              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="DEPARTMENT OF :  " />
                </View>
                <View style={styles.row}>
                  <Text content="UHID                      : " />
                  <Text content={`${data.uhid}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Patient Name         : " style={styles.textBold} />
                  <Text content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Age/Gender           : " style={styles.textBold} />
                  <Text content={`${data.patient.age}/${data.patient.gender}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Relative Name       : " style={styles.textBold} />
                  <Text content={`${data.care_taker.name_1}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Relative Mobile      : " style={styles.textBold} />
                  <Text content={`${data.care_taker.mobile_1}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Address                 : " style={styles.textBold} />
                  <Text content={`${data.patient.address.address}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Doctor Name         : " style={styles.textBold} />
                  <Text content={`${data.consultant_detail.doctor.name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Department           : " style={styles.textBold} />
                  <Text content={`${data.consultant_detail.department.department}`} />
                </View>
              </View>

              <View style={{ ...styles.column }}>
                <View style={styles.row}>
                  <Text content="Sponsor              : " style={styles.textBold} />
                  <Text content={`${data.patient.sponsor.name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="IPD NO               : " />
                  <Text content={`${data.ipd_no}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Adm. Date/Time  : " style={styles.textBold} />
                  <Text content={`${formatDate(data?.date)} ${formatRegTime(data?.time)}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Adm. Type           : " style={styles.textBold} />
                  <Text content={`${data.adm_type?.admission_type}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Phone No.           : " style={styles.textBold} />
                  <Text content={`${data.patient.address.mobile}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Guardian             : " style={styles.textBold} />
                  <Text content={`${data.patient.guardian_name}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Relation              : " style={styles.textBold} />
                  <Text content={`${data.patient.guardian_type[0]?.name || ''}`} />
                </View>
                <View style={styles.row}>
                  <Text content="Ward/Room/Bed : " style={styles.textBold} />
                  <Text
                    content={`${data.consultant_detail.room.ward.name} / ${data.consultant_detail.room.room_no} / ${data.consultant_detail.bed_no}`}
                  />{' '}
                  /
                </View>
              </View>
            </View>

            {/* Second Row */}
            <View style={styles.contentContainer1}>
              <View style={styles.column}>
                <View style={{ ...styles.row, marginLeft: '18%' }}>
                  <Text
                    style={styles.fontBold}
                    content="If Hospital Employee or his/her dependent is admitted, please complete the information below"
                  />
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="NAME AND DESIGNATION OF EMPLOYEE " />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="RELATIONSHIP OF PATIENT WITH EMPLOYEE" />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, fontSize: 8 }} content="WARD ENTITLEMENT" />
                </View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text style={{ ...styles.text, marginLeft: '40%' }} content="TRANSFER RECORD" />
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DATE" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DEPARTMENT" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="UNIT" />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="WARD" />
                </View>
              </View>
            </View>
            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            {/* <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View> */}
            {/* <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View> */}

            {/* <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DISCHARGED" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="LAMA" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DOPR" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="REFERAL" />
                </View>
              </View>
            </View> */}
            <View style={{ borderTop: '1px solid black' }}></View>
            <View>
              <View style={{ ...styles.row, width: '100%' }}>
                <Text
                  style={{
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    marginLeft: '40%',
                    marginTop: '2%',
                    textDecoration: 'underline'
                  }}
                  content="Declaration"
                />
              </View>

              <Text
                style={{ padding: '10px', fontSize: '10px' }}
                content="Above category has been opted by me and all expense involve in the course of treatment during admission have been explained to me. We agree to make all the payment before discharge per policy of the hospital in case I/We change from lower to higher category I/We Undertaker to pay the charge as per higher category from the date of admission.Also I shall be responsible for whatever money or valuable I bring to the hospital and keep the same entirely at my bonded"
              />

              <Text
                style={{ padding: '10px', fontSize: '10px' }}
                content={`In case authorisation of cashless service is not received from the medical insurance company/empanelled Company/TPA Sponsored on time. I/We hereby undertake to clear my dues before discharge. I/We hereby give consent to the hospital for carrying out treatment of my patient ${data.patient.first_name} ${data.patient.last_name} including investigations, medication, and operation under any kind of anaesthesia at my own risk.`}
              />
            </View>

            <View>
              <Text
                style={{ padding: '10px', fontSize: '10px' }}
                content={`We Mrs/Mr.................................................MobNo............................&Mrs./Mr...........................Mob No..........................Shall be responsible regarding the payments of the Bill of our patient ${data.patient.first_name} ${data.patient.last_name}`}
              />
            </View>

            {/* <View>
              <Text
                style={{ padding: '10px', fontSize: '10px', fontFamily: 'Roboto', textDecoration: 'underline' }}
                content="The hospital has a policy of advanced deposit please insure that your patient account remain in credit kindly operate by collecting your patient provisional account statement every alternate day from the billing counter before 12 noon otherwise it would be sent to the patient room after 12 noon please insure that the required amount is deposit by 2:00 p.m. "
              />
            </View> */}

            <View>
              <Text
                style={{ padding: '10px', fontSize: '10px' }}
                content="Addmission without Advance Authorized By : .............................Sign Of Patient/Attendent "
              />
            </View>
            <View style={styles.contentContainer}>
              <View style={styles.column}>
                <View style={styles.row}>
                <Text style={{ ...styles.text,marginRight:"5%" }} content="MLC Y/N" />
                  <View style={styles.voidBox}></View>
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="FIR No            :" style={styles.textBold} />
                </View>
              </View>
         
           
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Date & Time         :" />
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Buckle No.      :" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.wideColumn,marginLeft:"33%" }}>
                <View style={styles.row}>
                  <Text content="Police Station       :" style={styles.textBold} />
                </View>
              </View>
            </View>

            <View style={styles.contentContainer}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Contact No.    :" style={styles.textBold} />
                </View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}>
                  <Text content="Undertaking Sign  :" />
                </View>
              </View>
            </View>

            <View style={{ ...styles.contentContainer, padding: 15 }}>
              <View style={{ ...styles.wideColumn }}>
                <View style={styles.row}>
                  <Text content="Result :" style={styles.textBold} />
                </View>
              </View>
            </View>

            {/* Thired Row */}
            <View style={styles.contentContainer}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DISCHARGED" style={styles.textBold} />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="LAMA" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="DOPR" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="REFERAL" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="EXPIRED" />
                </View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}>
                  <Text content="ABSCONDED" />
                </View>
              </View>
            </View>

            <View style={{ ...styles.contentContainer, padding: 5 }}>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={{ ...styles.column, borderRight: '0.5px solid black' }}>
                <View style={styles.row}></View>
              </View>
              <View style={styles.column}>
                <View style={styles.row}></View>
              </View>
            </View>
            {/* --------------------------------Old Format ----------------------------- */}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};
